"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTreeCard = exports.StyledTitle = exports.StyledOption = exports.StyledEditDiv = exports.StyledArrow = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledTreeCard = _styledComponents.default.div.withConfig({
  displayName: "style__StyledTreeCard",
  componentId: "sc-16nku2f-0"
})(["box-sizing:border-box;width:276px;padding:", ";", ";background:", ";border-radius:10px;box-shadow:0px 5px 20px rgba(115,127,143,0.1);border:2px solid transparent;word-break:break-all;cursor:default;:focus{outline:none;background:", ";", "}", ""], ({
  editMode
}) => editMode ? '0px 16px' : '16px 6px 16px 16px', _shared.theme.typography.link.css, _shared.theme.palette.brand.primary.white, _shared.theme.palette.brand.primary.white, ({
  selected
}) => !selected && `border: 2px solid ${_shared.theme.palette.ui.cta.yellow};`, ({
  selected
}) => selected && `border: 2px solid ${_shared.theme.palette.ui.cta.blue};`);

exports.StyledTreeCard = StyledTreeCard;

const StyledEditDiv = _styledComponents.default.div.withConfig({
  displayName: "style__StyledEditDiv",
  componentId: "sc-16nku2f-1"
})(["display:flex;align-items:center;.editText input{border-bottom:none;}.editText::placeholder{", ";}.saveButton{margin-right:5px;width:32px;height:32px;}.cancelButton{background-color:#fff;border-color:#000;width:32px;height:32px;}.cancelButton .icon path{fill:", ";}"], _shared.theme.typography.link.css, _shared.theme.palette.brand.primary.charcoal);

exports.StyledEditDiv = StyledEditDiv;

const StyledTitle = _styledComponents.default.div.withConfig({
  displayName: "style__StyledTitle",
  componentId: "sc-16nku2f-2"
})(["position:relative;display:flex;align-items:center;color:", ";padding-right:10px;font-family:", ";font-size:", ";line-height:", ";"], _shared.theme.palette.brand.primary.charcoal, _shared.theme.typography.link.fontFamily, _shared.theme.typography.link.fontSize, _shared.theme.typography.h6.lineHeight);

exports.StyledTitle = StyledTitle;

const StyledArrow = _styledComponents.default.span.withConfig({
  displayName: "style__StyledArrow",
  componentId: "sc-16nku2f-3"
})(["margin-right:10px;transition:all 0.2s ease;", ""], ({
  isEnabled
}) => !isEnabled && `
		svg > path{
			fill:${_shared.theme.palette.brand.primary.charcoal};
		}
		transform:rotate(180deg);
	`);

exports.StyledArrow = StyledArrow;

const StyledOption = _styledComponents.default.span.withConfig({
  displayName: "style__StyledOption",
  componentId: "sc-16nku2f-4"
})(["position:absolute;right:0px;display:inline-block;z-index:1;padding:10px;cursor:pointer;"]);

exports.StyledOption = StyledOption;